const SET_HORIZON_LENGTH = 'SET_HORIZON_LENGTH';
const SET_SELECTED_FINANCING = 'SET_SELECTED_FINANCING';
const SET_PIE_SLIDER = 'SET_PIE_SLIDER';
const TOGGLE_ANNUAL_MONTH = 'TOGGLE_ANNUAL_MONTH';
const TOGGLE_LOADING = 'TOGGLE_LOADING';
const TOGGLE_DELETE = 'TOGGLE_DELETE';
const TOGGLE_PROPOSAL_VIEW = 'TOGGLE_PROPOSAL_VIEW';


export {
    SET_HORIZON_LENGTH,
    SET_SELECTED_FINANCING,
    SET_PIE_SLIDER,
    TOGGLE_ANNUAL_MONTH,
    TOGGLE_LOADING,
    TOGGLE_DELETE,
    TOGGLE_PROPOSAL_VIEW,
};



// WEBPACK FOOTER //
// ./src/containers/common/settings/constants.js